import type { CSSProperties, HTMLAttributes } from "react"

import { cn } from "@/lib/utils"

interface DotPatternProps extends HTMLAttributes<HTMLDivElement> {
  /** Abstand der Punkte waagerecht in px */
  width?: number
  /** Abstand der Punkte senkrecht in px */
  height?: number
  /** Versatz des Musters in px */
  x?: number
  y?: number
  /** Lage des Punkts innerhalb einer Kachel in px */
  cx?: number
  cy?: number
  /** Punktradius in px */
  cr?: number
}

/**
 * Punktraster als CSS-Hintergrund. Die SVG-Variante von Magic UI erzeugt für jeden
 * Punkt ein eigenes Element (mehrere Hundert pro Karte) und misst dafür beim Laden die
 * Größe. Ein Verlauf mit background-repeat sieht gleich aus und kostet nichts.
 * Farbe über text-*, wie bei der Vorlage.
 */
export function DotPattern({
  width = 16,
  height = 16,
  x = 0,
  y = 0,
  cx = 1,
  cy = 1,
  cr = 1,
  className,
  style,
  ...props
}: DotPatternProps) {
  return (
    <div
      aria-hidden="true"
      className={cn("pointer-events-none absolute inset-0 h-full w-full text-neutral-400/80", className)}
      style={
        {
          backgroundImage: `radial-gradient(circle at ${cx}px ${cy}px, currentColor ${cr}px, transparent ${cr + 0.5}px)`,
          backgroundSize: `${width}px ${height}px`,
          backgroundPosition: `${x}px ${y}px`,
          ...style,
        } as CSSProperties
      }
      {...props}
    />
  )
}
